var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4001 6.4C14.4003 7.14974 14.2249 7.8891 13.8879 8.55884C13.5509 9.22858 13.0618 9.81007 12.4596 10.2567C11.8574 10.7033 11.159 11.0027 10.4203 11.1308C9.68155 11.2589 8.9231 11.2122 8.2057 10.9944L8.0001 11.2L7.2001 12L6.4001 12.8H4.8001V14.4H1.6001V11.2L5.0057 7.7944C4.80606 7.13441 4.75095 6.43916 4.84413 5.75596C4.93731 5.07276 5.1766 4.41766 5.54569 3.83524C5.91479 3.25282 6.40503 2.75676 6.98305 2.38082C7.56108 2.00488 8.21331 1.75788 8.89536 1.65665C9.57741 1.55541 10.2733 1.60231 10.9356 1.79415C11.5979 1.98599 12.2111 2.31827 12.7334 2.76837C13.2558 3.21848 13.675 3.77584 13.9626 4.40251C14.2502 5.02919 14.3994 5.71048 14.4001 6.4ZM9.6001 3.2C9.38792 3.2 9.18444 3.28429 9.03441 3.43432C8.88438 3.58435 8.8001 3.78783 8.8001 4C8.8001 4.21218 8.88438 4.41566 9.03441 4.56569C9.18444 4.71572 9.38792 4.8 9.6001 4.8C10.0244 4.8 10.4314 4.96857 10.7315 5.26863C11.0315 5.56869 11.2001 5.97566 11.2001 6.4C11.2001 6.61218 11.2844 6.81566 11.4344 6.96569C11.5844 7.11572 11.7879 7.2 12.0001 7.2C12.2123 7.2 12.4158 7.11572 12.5658 6.96569C12.7158 6.81566 12.8001 6.61218 12.8001 6.4C12.8001 5.55131 12.463 4.73738 11.8628 4.13726C11.2627 3.53714 10.4488 3.2 9.6001 3.2Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.ed50e1a7f28e6f5cc101cd01ec0b46c0.svg";
export { ForwardRef as ReactComponent };